// extracted by mini-css-extract-plugin
module.exports = {"noVacancyCard":"styles-styles-module--noVacancyCard--2ckCS","vacancyCard":"styles-styles-module--vacancyCard--Q1CbN"};